import { defineComponent as _defineComponent } from 'vue'
import {
  Modal,
  HeadingDisplay,
  ButtonContainer,
  ButtonPrimary,
  ButtonSecondary,
  InitialAvatarIcon
} from '@warrenbrasil/nebraska-web';
import { Portal } from '@/modules/common/components/Portal';
import { Ref, inject } from 'vue';
import { isBFFError } from '@/modules/common/helpers/bff';
import { notify } from '@/modules/common/helpers/notification';
import { NotificationTypes } from '@/modules/common/services/http/notification';

interface Props {
  isOpen: boolean;
}
interface EmitEvents {
  (event: 'close'): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'DeallocateLimitsModal',
  props: {
    isOpen: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'close'): void;
}), expose: any, slots: any, attrs: any }) {




const fetchUpdateLimits = inject('fetchUpdateLimits', async () => ({}));

const updateDataForm = inject(
  'updateDataForm',
  (key: string, value: object) => ({
    key,
    value
  })
);

const dataForm = inject('dataForm') as Ref<{ isUpdatingLimits: boolean }>;

async function confirmDealocate() {
  updateDataForm('balance', { value: 0, formatted: '' });
  updateDataForm('drawdown', { value: 0, formatted: '' });
  try {
    await fetchUpdateLimits();
  } catch (e) {
    let errorMessage =
      'Houve um problema ao desalocar seus limites. Tente novamente em breve.';

    if (isBFFError(e)) {
      errorMessage = e.error.message.formatted;
    }

    notify({
      group: 'wrn-notifications',
      text: errorMessage,
      type: NotificationTypes.error
    });
  } finally {
    emit('close');
  }
}

return { __sfc: true,emit, fetchUpdateLimits, updateDataForm, dataForm, confirmDealocate, Modal, HeadingDisplay, ButtonContainer, ButtonPrimary, ButtonSecondary, InitialAvatarIcon, Portal }
}

})